var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.20012C8.75 2.53739 8.66272 2.00012 8 2.00012C7.33728 2.00012 7.25 2.83739 7.25 3.50012V7.25012H3.125C2.46226 7.25012 2 7.3374 2 8.00012C2 8.66284 2.53726 8.75012 3.2 8.75012H7.25V12.8001C7.25 13.4628 7.33728 14.0001 8 14.0001C8.66272 14.0001 8.75 13.4628 8.75 12.8001V8.75012H12.8C13.4627 8.75012 14 8.66284 14 8.00012C14 7.3374 13.4627 7.25012 12.8 7.25012H8.75V3.20012Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.24f159db1fdbb70810cc1f99bd7f5259.svg";
export { ForwardRef as ReactComponent };